import { CSSProperties } from 'react';
import styled from 'styled-components';

import { sizes } from '../../theme/sizes';

interface Props {
  columns?: CSSProperties['gridTemplateColumns'];
  rows?: CSSProperties['gridTemplateRows'];
  gapSize?: 'none' | 'sm' | 'md' | 'lg' | 'initial' | string;
  columnGap?: 'none' | 'sm' | 'md' | 'lg' | 'initial' | string;
  rowGap?: 'none' | 'sm' | 'md' | 'lg' | 'initial' | string;
}

export const Grid = styled.div<Props>`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || 'initial'};
  grid-template-rows: ${({ rows }) => rows || 'initial'};

  ${({ gapSize, columnGap, rowGap }) => {
    const getGapValue = (value: string | undefined) => {
      if (!value || value === 'none') return '0';
      return sizes[value as keyof typeof sizes] ?? value;
    };

    // If columnGap or rowGap are defined, we use column-gap and row-gap properties
    // instead of the general gap property for better control over individual spacing

    if (columnGap !== undefined || rowGap !== undefined) {
      let colValue = 'initial';
      let rowValue = 'initial';

      if (columnGap !== undefined) {
        colValue = getGapValue(columnGap);
      } else if (gapSize !== undefined) {
        colValue = getGapValue(gapSize);
      }

      if (rowGap !== undefined) {
        rowValue = getGapValue(rowGap);
      } else if (gapSize !== undefined) {
        rowValue = getGapValue(gapSize);
      }

      return `
        column-gap: ${colValue};
        row-gap: ${rowValue};
      `;
    }

    if (gapSize !== undefined) {
      return `gap: ${getGapValue(gapSize)};`;
    }

    return '';
  }}
`;
